
import { mapGetters } from "vuex";

const WIDGET = "REFINEMENT_LIST";

export default {
  props: {
    checkbox: { type: Boolean, default: true },
    facet: { type: Object, required: true },
  },

  data() {
    return {
      open: false,
      showAll: false,
    };
  },

  computed: {
    ...mapGetters("productsSearch", ["getFacetValues"]),
    items() {
      return this.getFacetValues(this.facet.field);
    },
    visibleItems() {
      return this.showAll ? this.items : this.items.slice(0, 10);
    },
  },

  watch: {
    "facet.facet_active": {
      handler(value) {
        this.open = this.open ? this.open : Boolean(value);
      },
      immediate: true,
    },
  },

  created() {
    this.$nuxt.$on("clear-all", () => {
      this.open = false;
      this.showAll = false;
    });
  },

  methods: {
    toggleViewMore() {
      this.showAll = !this.showAll;
    },
    refine(value) {
      try {
        this.$store.dispatch("productsSearch/refine", {
          widget: WIDGET,
          facet: { ...this.facet, value },
        });
      } catch (error) {
        this.$bugsnag.notify(error);
      }
    },
  },
};
